var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "184px",
    height: "184px",
    viewBox: "-0.5 -0.5 184 184",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2024-01-10T09:00:52.532Z\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36\" etag=\"FK6zGiZ_4u_3MMV9tFpG\" version=\"22.1.18\" type=\"device\"><diagram name=\"\\u30DA\\u30FC\\u30B81\" id=\"XO5jSbCthejDR25AwYky\">vZVLU8IwEIB/TY86TQt9HC0gXhwdOXiOdGkzpk1Ngy38erc26WOAAWZQDkzy7eb17Q5Y7iyrl5IW6bOIgVuOHdeWO7cc/Hj43YCdBlO3BYlkcYtID1ZsDxramm5ZDOUoUQnBFSvGcC3yHNZqxKiUohqnbQQfn1rQBA7Aak35IX1nsUpbGjh+z5+AJak5mXhhG8moSdYvKVMai2qA3IXlzqQQqh1l9Qx44854adc9noh2F5OQq0sW7LdR+R6/em9AvpJ8CXwevdzpXb4p3+oH68uqnTGAu6BsnERVyhSsCrpuIhWWG1mqMo4zgkNaFm0FNqwGPDTaMM5ngguJLBd5s0WppPgEAy3HpdPQD6ZdxDhGO5G+GkgF9ck3k84kdiCIDJTcYYpeEAbtCt18oW7Gqq8kCXR50mEVDaS6e5Ju514wDrTjK3z7530nUmyLk2/XfU4/TLp9rRPij6WQyREr/r3JGnoJSIdvbsb5r07EpnsYN92xdryo+U6X+NC+tu1NLpU9wDeXPTkvG7swjxt5c/u88Mv9eqH3N37PC51OrraJ0/4H+jc2+JdzFz8=</diagram></mxfile>",
    style: {
      backgroundColor: "rgba(255, 255, 255, 0)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 92,
    cy: 92,
    rx: 90,
    ry: 90,
    fill: "none",
    stroke: "#a59785",
    strokeWidth: 2,
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.89,
    cy: 124.89,
    rx: 8.89,
    ry: 8.89,
    fill: "#a59785",
    stroke: "#a59785",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 52,
    width: 17.78,
    height: 54,
    fill: "#A59785",
    stroke: "#A59785",
    pointerEvents: "all"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.28bbd79709934bc5fd871bfe03f1f255.svg";
export { ForwardRef as ReactComponent };